export enum ImportProjectModelOption {
  ImportFromJson = 'importFromJson',
  ImportFromPostgreSQL = 'importFromPostgreSQL',
  ImportFromOpenApiSpecs = 'importFromOpenApiSpecs'
}
